export const InputAreaSelectionEnum = {
    AREA_NAME: Symbol("SELECT_AREA"),
    CELL: Symbol("CUSTOM_SELECTION")
}